import { TKUITheme } from "../jss/TKUITheme";

export const tKUIFriendlinessColors = {
    safe: '#1ec862',
    unsafe: '#f8e658',
    dismount: 'red',
    unknown: '#d8d8d8'
};

export const tKUIStreetsChartDefaultStyle = (theme: TKUITheme) => ({
    main: {
        marginBottom: '10px',
        position: 'relative'
    }
});
